import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-success-header',
  templateUrl: './success-header.component.html',
  styleUrls: ['./success-header.component.css']
})
export class SuccessHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
